import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import WikiSearch from "./WikiSearch";

const WikiContents = ({ sections, backLink }) => {
  const [activeId, setActiveId] = useState(sections[0]?.[0] || "");

  useEffect(() => {
    if (!sections.length) return undefined;

    const updateActiveSection = () => {
      const viewportLine = window.innerHeight * 0.32;
      let currentId = sections[0][0];

      sections.forEach(([id]) => {
        const element = document.getElementById(id);
        if (!element) return;

        if (element.getBoundingClientRect().top <= viewportLine) {
          currentId = id;
        }
      });

      setActiveId(currentId);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("resize", updateActiveSection);

    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, [sections]);

  return (
    <aside className="wiki-contents" aria-label="Wiki contents">
      <WikiSearch />
      {backLink && (
        <Link className="wiki-back-link" to={backLink.href}>
          {backLink.label}
        </Link>
      )}
      <nav>
        {sections.map(([id, label]) => (
          <a
            className={activeId === id ? "is-active" : undefined}
            href={`#${id}`}
            key={id}
          >
            {label}
          </a>
        ))}
      </nav>
    </aside>
  );
};

export default WikiContents;
